{
  "ai": {
    "title": "ผู้ช่วย AI",
    "saved": "บันทึกการตั้งค่าสำเร็จ",
    "loadError": "ไม่สามารถโหลดการตั้งค่าผู้ช่วย AI ได้",
    "dirty": "มีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก",
    "save": "บันทึกการตั้งค่า",
    "tabs": {
      "general": "ทั่วไป",
      "business": "ข้อมูลธุรกิจ",
      "payment": "การชำระเงิน",
      "usage": "การใช้งาน"
    },
    "general": {
      "enabled": "เปิดใช้งานผู้ช่วย AI",
      "enabledHelp": "เมื่อเปิด บอทจะตอบลูกค้าโดยอัตโนมัติในช่องทางที่เลือก",
      "authority": "สิทธิ์การทำงานของบอท",
      "authorityHelp": "กำหนดว่าบอทจะสร้างคำสั่งซื้อได้เองหรือต้องรอการอนุมัติ",
      "channels": "ช่องทางที่ AI ตอบ",
      "customerConfirm": "ให้ลูกค้ายืนยัน",
      "adminApprove": "ให้แอดมินอนุมัติ",
      "tone": "โทนการตอบ",
      "friendly": "เป็นกันเอง",
      "formal": "ทางการ",
      "playful": "สนุกสนาน",
      "replyLanguage": "ภาษาที่ใช้ตอบ",
      "automaticLanguage": "อัตโนมัติ (ตามภาษาของลูกค้า)",
      "thai": "ไทย",
      "english": "อังกฤษ",
      "customNotes": "หมายเหตุเรื่องน้ำเสียง",
      "customNotesHelp": "กำหนดน้ำเสียงและการใช้คำของ AI เช่น เรียกลูกค้าว่า คุณลูกค้า ส่วนค่าส่ง เงื่อนไขส่งฟรี และข้อมูลร้าน ให้ตั้งในหน้าการจัดส่งและแท็บข้อมูลธุรกิจ",
      "customNotesPlaceholder": "เช่น เรียกลูกค้าว่า คุณลูกค้า"
    },
    "business": {
      "description": "คำอธิบายธุรกิจ",
      "descriptionHelp": "บอทใช้ข้อมูลนี้เพื่อแนะนำร้านและสินค้าให้ลูกค้า",
      "descriptionPlaceholder": "เช่น ร้านขายเสื้อผ้าแฟชั่นผู้หญิง จัดส่งทั่วประเทศ",
      "faq": "คำถามที่พบบ่อย (FAQ)",
      "questionRequired": "กรุณากรอกคำถาม",
      "questionPlaceholder": "คำถาม เช่น จัดส่งกี่วัน?",
      "answerRequired": "กรุณากรอกคำตอบ",
      "answerPlaceholder": "คำตอบ เช่น จัดส่งภายใน 2-3 วันทำการ",
      "remove": "ลบ",
      "addQuestion": "เพิ่มคำถาม",
      "shippingPolicy": "นโยบายการจัดส่ง",
      "shippingPlaceholder": "เช่น จัดส่งฟรีเมื่อซื้อครบ 500 บาท ส่งภายใน 2-3 วัน",
      "returnPolicy": "นโยบายการคืนสินค้า",
      "returnPlaceholder": "เช่น คืนสินค้าได้ภายใน 7 วันหากสินค้าชำรุด"
    },
    "channels": {
      "intro": "เลือกช่องทางที่ต้องการให้บอทตอบลูกค้าโดยอัตโนมัติ",
      "notConnected": "ยังไม่ได้เชื่อมต่อ",
      "connectHere": "เชื่อมต่อที่นี่",
      "connectFirst": "เชื่อมต่อช่องทางนี้ก่อนเปิดใช้บอท"
    },
    "payment": {
      "bankAccounts": "บัญชีธนาคาร",
      "bankRequired": "กรุณากรอกชื่อธนาคาร",
      "bankPlaceholder": "ชื่อธนาคาร เช่น ไทยพาณิชย์",
      "accountNumberRequired": "กรุณากรอกเลขที่บัญชี",
      "accountNumberPlaceholder": "เลขที่บัญชี",
      "accountNameRequired": "กรุณากรอกชื่อบัญชี",
      "accountNamePlaceholder": "ชื่อบัญชี",
      "remove": "ลบ",
      "addAccount": "เพิ่มบัญชี",
      "promptPayHelp": "อัปโหลดรูป QR เพื่อให้บอทส่งให้ลูกค้าตอนชำระเงิน",
      "promptPayQrAlt": "คิวอาร์โค้ดพร้อมเพย์",
      "instructions": "คำแนะนำการชำระเงิน",
      "instructionsPlaceholder": "เช่น โอนแล้วแนบสลิปในแชทได้เลยค่ะ"
    },
    "upload": {
      "imageOnly": "รองรับเฉพาะไฟล์รูปภาพ (JPEG, PNG, WebP)",
      "tooLarge": "ไฟล์ต้องมีขนาดไม่เกิน 1 MB",
      "failed": "อัปโหลด QR ไม่สำเร็จ กรุณาลองอีกครั้ง",
      "uploaded": "อัปโหลดแล้ว",
      "remove": "ลบรูป",
      "replace": "เปลี่ยนรูป",
      "upload": "อัปโหลด QR PromptPay"
    },
    "usage": {
      "loadError": "ไม่สามารถโหลดข้อมูลการใช้งานได้",
      "today": "วันนี้",
      "used": "ใช้ไปแล้ว",
      "limit": "ขีดจำกัด",
      "remaining": "คงเหลือ",
      "tokens": "โทเค็น",
      "recent": "7 วันล่าสุด"
    },
    "loadFallback": "ไม่สามารถโหลดการตั้งค่า AI ได้",
    "saveFallback": "บันทึกการตั้งค่า AI ไม่สำเร็จ",
    "leave": {
      "title": "ยังไม่ได้บันทึกการเปลี่ยนแปลง",
      "body": "ถ้าออกจากหน้านี้ตอนนี้ การเปลี่ยนแปลงที่ยังไม่ได้บันทึกจะหายไป รวมถึงการเปิดหรือปิดผู้ช่วย AI",
      "confirm": "ออกโดยไม่บันทึก",
      "cancel": "อยู่ต่อ"
    }
  },
  "delivery": {
    "title": "การจัดส่ง",
    "saved": "บันทึกการตั้งค่าการจัดส่งสำเร็จ",
    "loadError": "ไม่สามารถโหลดการตั้งค่าการจัดส่งได้",
    "fee": "ค่าจัดส่ง (บาท)",
    "feeHelp": "คิดค่าส่งนี้ต่อหนึ่งออเดอร์ ใส่ 0 หากส่งฟรี",
    "feePlaceholder": "เช่น 50",
    "freeOver": "ส่งฟรีเมื่อยอดถึง (บาท)",
    "freeOverHelp": "เว้นว่างไว้หากไม่มีโปรส่งฟรี",
    "freeOverPlaceholder": "เช่น 500",
    "dirty": "มีการเปลี่ยนแปลงที่ยังไม่ได้บันทึก",
    "save": "บันทึกการตั้งค่า",
    "loadFallback": "ไม่สามารถโหลดการตั้งค่าได้",
    "saveFallback": "บันทึกการตั้งค่าไม่สำเร็จ"
  }
}
